<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>供需信息</BreadcrumbItem>
          <BreadcrumbItem>商机供需</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">商机供需</div>

        <div style="display:flex;margin-top:15px">
          <Cascader change-on-select
                    v-model="form.category"
                    :data="type"
                    filterable
                    @on-change="changeCategory"
                    placeholder="输入关键词进行类别搜索"
                    style="width: 400px;"></Cascader>

          <Date-picker v-model="oppTime"
                       format="yyyy-MM-dd"
                       type="daterange"
                       placement="bottom-end"
                       placeholder="选择日期"
                       style="width: 200px;margin-left:15px"></Date-picker>

          <el-input placeholder="请输入搜索的内容"
                    size="small"
                    class="marLeft"
                    style="width: 200px;"
                    v-model="searchField"
                    clearable>
          </el-input>
          <el-button type="primary"
                     size="small"
                     @click="searchChick()"
                     class="marLeft">搜索</el-button>
        </div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item"
             @click="hostExcelExportBack">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false"
            @on-click="switchBrand"
            v-model="showTabs">
        <TabPane :label="showTabs=='0'?'待推送'+'('+totalCount+')':'待推送'"
                 name="0">
        </TabPane>
        <TabPane :label="showTabs=='1'?'已推送'+'('+totalCount+')':'已推送'"
                 name="1">
        </TabPane>
        <TabPane :label="showTabs=='2'?'被驳回'+'('+totalCount+')':'被驳回'"
                 name="2">
        </TabPane>
      </Tabs>
    </div>

    <div class="layout-content"
         style="background: transparent;">
      <!-- <div v-if="list.length"> -->
      <div v-if="list.length">
        <Table :columns="showTabs=='1' ?columns:columnsNoHandel"
               :loading="loading"
               :data="list">
          <template slot-scope="{ row }"
                    slot="typeOpp">{{row.publishType}}</template>
          <template slot-scope="{ row }"
                    slot="nameOpp">{{row.name}}</template>
          <template slot-scope="{ row }"
                    slot="comOpp">{{row.companyName}}</template>
          <template slot-scope="{ row }"
                    slot="phoneOpp">{{row.phone}}</template>
          <template slot-scope="{ row }"
                    slot="identityOpp">{{row.idnentityType}}</template>
          <template slot-scope="{ row }"
                    slot="proOpp">
            <!-- <span v-if="JSON.parse(row.productType)"> {{JSON.parse(row.productType).Value}}
              <span v-if="JSON.parse(row.productType).List">/{{JSON.parse(row.productType).List[0].Value}}
                <span v-if="JSON.parse(row.productType).List[0].List"> /{{JSON.parse(row.productType).List[0].List[0].Value}}
                  <span v-if="JSON.parse(row.productType).List[0].List[0].List"> /{{JSON.parse(row.productType).List[0].List[0].List[0].Value}}
                  </span>
                </span>
              </span>
            </span> -->
            {{row.productType?row.productType:row.type2}}
          </template>
          <template slot-scope="{ row }"
                    slot="endTimeOpp">
            <span v-if="row.endTime">{{row.endTime | dateFormat}}</span>
          </template>
          <template slot-scope="{ row }"
                    slot="upTimeOpp">
            <span v-if="row.inTime">{{row.inTime | dateFormat}}</span>
          </template>
          <template slot-scope="{ row }"
                    slot="matNumOpp">
            {{row.bindCount}}
          </template>
          <template slot-scope="{ row }"
                    slot="answerNumOpp">
            {{row.subCount}}
          </template>
          <template slot-scope="{ row }"
                    slot="show">
            <iSwitch v-model="row.isShow"
                     @on-change="showToggle(row)" />
          </template>
          <template slot-scope="{ row }"
                    slot="isdeal">
            <!-- 0 -->
            <div v-if="showTabs=='0'">
              <span class="lookClass"
                    style="cursor:pointer"
                    @click="detailInfo(row,'1')">查看</span>

              <span class="spanClass">|</span>
              <span class="deleteClass"
                    style="cursor:pointer"
                    @click="rejectP(row,'0')">驳回</span>
            </div>
            <!-- 1 -->
            <div v-if="showTabs=='1'">
              <span class="lookClass"
                    style="cursor:pointer"
                    @click="detailInfo(row,'1')">查看</span>
            </div>
            <!-- 2 -->
            <div v-if="showTabs=='2'">
              <Poptip confirm
                      :title="PoptipTitle"
                      @on-ok="setAudit(row)"
                      placement="left">
                <span class="lookClass"
                      @click="handleP(row,'3')">再激活</span>
              </Poptip>
            </div>
          </template>
        </Table>
        <div class="my-page"
             v-if="totalCount > pageSize"
             style="margin: 20px;text-align: center;">
          <Page show-total
                show-elevator
                :page-size="pageSize"
                :current="pageIndex"
                :total="totalCount"
                @on-change="changePage"
                @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div class="u-empty"
           v-else>暂无数据</div>
    </div>

    <iModal :title="modelTitle"
            v-model="rejectModel"
            class-name="vertical-center-modal"
            width="600px"
            :mask-closable="false">

      <Input v-model="rejectValue"
             type="textarea"
             :rows="4"
             placeholder="请输入..."></Input>

      <div slot="footer">
        <Button type="primary"
                @click="handleSubmitReject()">确定</Button>
        <Button @click="rejectModel=false">取消</Button>
      </div>
    </iModal>
    <div class="catalogue-content"></div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: 'exhibition-info-carApply',
  data() {
    return {
      productTypeOptions: [
        {
          value: '选项1',
          label: '黄金糕',
        },
      ],
      productTypeValue: '',

      modalDetail: false,
      loading: false,

      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: '',
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      columns: [
        {
          title: '类型',
          slot: 'typeOpp',
          align: 'center',
        },
        {
          title: '发布人',
          slot: 'nameOpp',
          align: 'center',
        },
        {
          title: '公司/机构',
          slot: 'comOpp',
          align: 'center',
        },
        {
          title: '电话',
          slot: 'phoneOpp',
          align: 'center',
        },
        {
          title: '身份',
          slot: 'identityOpp',
          align: 'center',
        },
        {
          title: '产品类型',
          slot: 'proOpp',
          align: 'center',
          width: 400,
        },
        {
          title: '截止日期',
          slot: 'endTimeOpp',
          align: 'center',
        },
        {
          title: '提交时间',
          slot: 'upTimeOpp',
          align: 'center',
        },
        {
          title: '匹配数量',
          slot: 'matNumOpp',
          align: 'center',
        },
        {
          title: '显示状态',
          slot: 'show',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'isdeal',
          align: 'center',
        },
      ],
      columnsNoHandel: [
        {
          title: '类型',
          slot: 'typeOpp',
          align: 'center',
        },
        {
          title: '发布人',
          slot: 'nameOpp',
          align: 'center',
        },
        {
          title: '公司/机构',
          slot: 'comOpp',
          align: 'center',
        },
        {
          title: '电话',
          slot: 'phoneOpp',
          align: 'center',
        },
        {
          title: '身份',
          slot: 'identityOpp',
          align: 'center',
        },
        {
          title: '产品类型',
          slot: 'proOpp',
          align: 'center',
          width: 400,
        },
        {
          title: '截止日期',
          slot: 'endTimeOpp',
          align: 'center',
        },
        {
          title: '提交时间',
          slot: 'upTimeOpp',
          align: 'center',
        },
        {
          title: '匹配数量',
          slot: 'matNumOpp',
          align: 'center',
        },
        {
          title: '应答数量',
          slot: 'answerNumOpp',
          align: 'center',
        },
        {
          title: '显示状态',
          slot: 'show',
          align: 'center',
        },
        {
          title: '操作',
          slot: 'isdeal',
          align: 'center',
        },
      ],
      oppTime: [],
      searchField: '',
      list: [],
      selection: [], // 选中项目
      addShow: false,
      rejectModel: false,
      modelTitle: '',
      rowUser: {},
      showTabs: '0',
      PoptipTitle: '',
      option: {},
      stateInit: '',
      rejectValue: '',
      form: {
        category: [], // 展品分类
      },
      type: [],
      idCategory: '',
    }
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: 'loginModule/getExhibition',
      exhibitionInfo: 'hostSetModule/getHostExhibition',
      hostExhibition: 'hostSetModule/getHostExhibition',
    }),
  },
  created() {
    document.title = '国际焙烤展 - 商机供需'
    this.initProType()
    this.init()
  },
  methods: {
    ...mapActions({
      getHostBuySupply: 'hostSetModule/getHostBuySupply',
      putHostUpdateState: 'hostSetModule/putHostUpdateState',
      getHostCallingAgain: 'hostSetModule/getHostCallingAgain',
      getBuyExport: 'hostSetModule/getBuyExport',
      //   商机
      busOppNewRealeaseGetPageList:
        'hostSetModule/busOppNewRealeaseGetPageList',
      getProductByGroupId: 'categoryModule/getProductByGroupId', // 获取  产品类别
      busOppNewRealeasePutUpdate: 'hostSetModule/busOppNewRealeasePutUpdate', // 修改
      busOppNewRealeaseExcelExportHost:
        'hostSetModule/busOppNewRealeaseExcelExportHost',
      newRealeaseSetIsShow: 'hostSetModule/newRealeaseSetIsShow',
    }),
    switchBrand(name) {
      this.init()
    },
    searchChick() {
      this.init()
      //     this.startDateStr = this.formatDate(this.oppTime[0])
      //   this.endDateStr = this.formatDate(this.oppTime[1])
    },
    // 转换日期格式
    formatDate(dateTime) {
      let date = new Date(dateTime)
      let YY = date.getFullYear() + '-'
      let MM =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let hh =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let mm =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let ss =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      //    return YY + MM + DD + " " + hh + mm + ss;
      return YY + MM + DD
    },

    async init() {
      let pushList = [
        {
          type: 1,
          Wheres: {
            WhereOperator: 6,
            Label: 'name',
            Value: `%${this.searchField || ''}%`,
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: this.showTabs == '0' || this.showTabs == '2' ? 0 : 3,
            Label: 'pushCount',
            Value: this.showTabs == '0' || this.showTabs == '2' ? 0 : 1,
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: 0,
            Label: 'refused',
            Value: this.showTabs == '2' ? 1 : 0,
          },
        },
      ] //传给后台的数组
      let listDome = [
        {
          type: 1,
          Wheres: {
            WhereOperator: 0,
            Label: 'categotyId',
            Value: this.idCategory,
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: 3,
            Label: 'inTime',
            // Value: this.formatDate(this.oppTime[0]),
            Value: '2022-05-19',
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: 5,
            Label: 'inTime',
            Value: this.formatDate(this.oppTime[1]),
          },
        },
      ]
      if (this.form.category != 0) {
        listDome.forEach((e) => {
          if (e.Wheres.Label == 'categotyId') {
            pushList.push(e)
          }
        })
      }
      if (this.oppTime[0]) {
        listDome.forEach((e) => {
          if (e.Wheres.Label == 'inTime') {
            pushList.push(e)
          }
        })
      }
      console.log(pushList, 'pppppppp')

      this.option = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        isSearchShow: true,
        Wheres: {
          type: 0,
          Wheres: {
            WhereGroupOperator: 0,
            Predicates: pushList,
          },
        },
      }
      this.loading = true
      let proData = await this.busOppNewRealeaseGetPageList(this.option)
      if (proData) {
        this.loading = false
        // this.list = proData.items
        let resList = proData.items
        this.pageSize = proData.pageSize
        this.pageIndex = proData.pageIndex
        this.totalCount = proData.totalCount
        resList.forEach((e) => {
          if (e.productType) {
            const category = JSON.parse(e.productType)
            const categoryArr = []
            if (category) {
              if (category.Value) {
                categoryArr.push(category.Value)
                if (category.List[0]) {
                  categoryArr.push(category.List[0].Value)
                  if (category.List[0].list) {
                    categoryArr.push(category.List[0].list[0].Value)
                  }
                }
               
                e.productType = categoryArr.join('/')
              }
            }
          }
        })
        this.list = resList
        console.log(this.list)
      } else {
        this.loading = false
      }
    },

    // 查询产品类别
    async initProType() {
      let categoryData = await this.getProductByGroupId({
        groupId: this.hostExhibition.groupId,
        level: 0,
        loadChild: true,
      }) // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map((c) => {
          c.value = c.name
          c.label = c.name
          c.children = JSON.parse(JSON.stringify(c.list))
          c.children.map((v) => {
            v.value = v.name
            v.label = v.name
            v.children = JSON.parse(JSON.stringify(v.list))
            v.children.map((z) => {
              z.value = z.name
              z.label = z.name
              z.children = JSON.parse(JSON.stringify(z.list))
            })
          })
        })
        this.type = categoryData
        console.log(this.type, '888888888')
      } else {
        this.type = []
      }
    },

    async setAllAudit() {
      const reqList = []
      if (!this.selection.length) return
      this.selection.forEach((c) => {
        reqList.push(c.joinId)
      })
      const bool = await this.setOneStepAudit({
        joinIds: reqList,
      })
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    changePage(e) {
      this.pageIndex = e
      this.init()
    },
    changePageSize(e) {
      this.pageSize = e
      this.init()
    },
    edit(item) {
      this.editInfo = item
    },
    searchPro() {
      this.pageIndex = 1
      this.init()
    },
    changeEvent(selection) {
      this.selection = selection
    },

    handleP(row, index) {
      this.PoptipTitle = '您确定要激活吗？'
    },
    async setAudit(row) {
      const option = {
        id: row.id,
        setValues: {
          ResusedReson: '',
          Refused: false,
        },
      }

      const bool = await this.busOppNewRealeasePutUpdate(option)
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
      //   if (this.showTabs == '3') {
      //     let date = new Date(+new Date() + 8 * 3600 * 1000)
      //       .toISOString()
      //       .replace(/T/g, ' ')
      //       .replace(/\.[\d]{3}Z/, '')
      //     let endTime1 = new Date(`${date}`).toJSON() //2035-09-14T08:31:49.000Z
      //     console.log(row)
      //     const opt = {
      //       id: row.id,
      //       setValues: {
      //         Intime: endTime1,
      //         State: 0,
      //       },
      //     }
      //     console.log(opt) 
      //     const bool = await this.putHostUpdateState(opt)
      //     if (bool && bool.successed) {
      //       this.$Message.success('操作成功')
      //       this.init()
      //     } else {
      //       this.$Message.error('操作失败，请重新尝试')
      //     }
      //   }
    },
    rejectP(row, index) {
      this.rejectValue = ''
      this.rowUser = row
      this.modelTitle = '请填写驳回原因：'
      this.rejectModel = true
      //   }
    },

    // 驳回确定按钮
    async handleSubmitReject() {
      if (!this.rejectValue) {
        this.$Message.warning('驳回理由不能为空！')
        return
      }
      const option = {
        // id: this.rowUser.id,
        id: this.rowUser.id,
        setValues: {
          ResusedReson: this.rejectValue,
          Refused: true,
        },
      }
      let bool = await this.busOppNewRealeasePutUpdate(option)
      if (bool && bool.successed) {
        this.rejectModel = false
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
      //   }
    },
    // 主办导出
    async hostExcelExportBack() {
      let pushList = [
        {
          type: 1,
          Wheres: {
            WhereOperator: 6,
            Label: 'name',
            Value: `%${this.searchField || ''}%`,
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: this.showTabs == '0' || this.showTabs == '2' ? 0 : 3,
            Label: 'pushCount',
            Value: this.showTabs == '0' || this.showTabs == '2' ? 0 : 1,
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: 0,
            Label: 'refused',
            Value: this.showTabs == '2' ? 1 : 0,
          },
        },
      ] //传给后台的数组
      let listDome = [
        {
          type: 1,
          Wheres: {
            WhereOperator: 0,
            Label: 'categotyId',
            Value: this.idCategory,
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: 3,
            Label: 'inTime',
            Value: this.formatDate(this.oppTime[0]),
          },
        },
        {
          type: 1,
          Wheres: {
            WhereOperator: 5,
            Label: 'inTime',
            Value: this.formatDate(this.oppTime[1]),
          },
        },
      ]
      if (this.form.category != 0) {
        listDome.forEach((e) => {
          if (e.Wheres.Label == 'categotyId') {
            pushList.push(e)
          }
        })
      }
      if (this.oppTime[0]) {
        listDome.forEach((e) => {
          if (e.Wheres.Label == 'inTime') {
            pushList.push(e)
          }
        })
      }
      console.log(pushList, 'pppppppp')

      let option = {
        pageSize: 500000,
        pageIndex: 1,
        Wheres: {
          type: 0,
          Wheres: {
            WhereGroupOperator: 0,
            Predicates: pushList,
          },
        },
      }
      let demo = {}
      demo.index = this.showTabs
      demo.option = option

      let data = await this.busOppNewRealeaseExcelExportHost(demo)

      //   if (this.showTabs == '0') {
      //     let opt = {
      //       pageSize: 500000,
      //       pageIndex: 1,
      //       hour24: false,
      //       conditions: {
      //         state: '0,2',
      //       },
      //     }
      //     let data = await this.busOppNewRealeaseExcelExportHost(opt)
      //   }
      //   if (this.showTabs == '1') {
      //     let opt = {
      //       pageSize: 500000,
      //       pageIndex: 1,
      //       hour24: true,
      //       conditions: {
      //         state: '0,2',
      //       },
      //     }
      //     let data = await this.busOppNewRealeaseExcelExportHost(opt)
      //   }
      //   if (this.showTabs == '2') {
      //     let opt = {
      //       pageSize: 500000,
      //       pageIndex: 1,
      //       hour24: true,
      //       conditions: {
      //         state: '1',
      //       },
      //     }
      //     let data = await this.busOppNewRealeaseExcelExportHost(opt)
      //   }
    },
    // 获取产品类别
    changeCategory(val) {
      let category = this.form.category
      if (val) {
        category = this.form.category = val
      }
      let data = null
      this.type.forEach((c) => {
        if (category[0] && c.name === category[0]) {
          this.idCategory = c.id
          data = {
            Id: c.id,
            Value: c.name,
            List: [],
          }
          if (c.list && c.list.length && category[1]) {
            c.list.forEach((v) => {
              if (v.name === category[1]) {
                this.idCategory = v.id
                data.List[0] = {
                  Id: v.id,
                  Value: v.name,
                }
                if (v.list && v.list.length && category[2]) {
                  v.list.forEach((j) => {
                    if (j.name === category[2]) {
                      this.idCategory = j.id
                      data.List[0].list = [
                        {
                          Id: j.id,
                          Value: j.name,
                          Remark: j.tag,
                        },
                      ]
                    }
                  })
                }
              }
            })
          }
        }
      })
      console.log(this.idCategory)
      return data
    },

    // 查看详情   传id
    detailInfo(row, index) {
      // this.$router.push('/host/index/supply-info/business-opportunity-detail')
      this.$router.push(
        `/host/index/supply-info/business-opportunity-detail?id=${row.id || ''}`
      )
    },
    // 修改展品显示、屏蔽
    async showToggle(item) {
      const bool = !!item.isShow
      let result = await this.newRealeaseSetIsShow({
        id: item.id,
        setValues: {
          IsShow: bool,
        },
      })
      if (result.successed) {
        this.$Message.success('修改成功')
        this.init()
      } else {
        this.$Message.error('修改失败，请重新尝试')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}

.deleteClass {
  color: #f78989;
  // cursor:pointer;
}
.lookClass {
  color: #1890ff;
  cursor: pointer;
}
.marLeft {
  margin-left: 15px;
}
</style>
